import { render } from "./OrderSingle.vue?vue&type=template&id=17c49024&scoped=true"
import script from "./OrderSingle.vue?vue&type=script&lang=js"
export * from "./OrderSingle.vue?vue&type=script&lang=js"

import "./OrderSingle.vue?vue&type=style&index=0&id=17c49024&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c49024"]])

export default __exports__